<template>
  <div class="wrap">
    <mt-header title="输入新手机号">
      <router-link to="/more/showinfo" slot="left">
        <span class="quxiao">取消</span>
      </router-link>
    </mt-header>
    <div class="main">
      <span class="tip">目前绑定手机号码是，请输入你希望绑定的新号码。</span>
    </div>
    <div class="phoneNum">
      <label class="label">手机号码</label>
      <input type="text" placeholder="请输入验证码" class="input" maxlength="6" autocomplete="off">
    </div>
    <div style="padding: 0 .4rem">
      <mt-button type="primary" size="large" class="btn" @click="sendNewmsg">发送验证码</mt-button>
    </div>
  </div>
</template>
<script>
 export default {
   data () {
     return {}
   },
   methods: {
     sendNewmsg () {
       // 这里需要发送请求
       var _this = this
       _this.$router.push({path: '/more/newphonecode'})
     }
   }
 }
</script>
<style scoped>
  .wrap {
    padding-top: .88rem;
    height: 100%;
    background: #f7f7fa;
  }

  .mint-header {
    position: fixed;
    top: 0;
    height: 1.28rem;
    width: 100%;
    background-color: #E4393C;
  }

  .quxiao {
    font-size: .28rem;
  }

  .mint-header-title {
    font-size: .36rem;
    font-weight: 500;
  }

  .mint-button-text {
    font-size: .28rem;
  }
  .main {
    padding: .2rem .54rem 0 .29rem;
  }

  .main .tip {
    color: #9b9b9b;
    font-size: .28rem;
    text-align: left;
  }
  .phoneNum {
    margin: .46rem 0 .3rem 0;
    background-color: #ffffff;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    height: .9rem;
    line-height: .9rem;
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 .3rem;
  }
  .input {
    display: inline-block;
    font-size: .28rem;
    border: 0;
    border-radius: 0;
    position: absolute;
    top: .25rem;
    outline: 0;
    color: #9b9b9b;
  }

  .label {
    font-size: .28rem;
    text-align: left;
    display: inline-block;
    color: #1d1f22;
    margin-right: .2rem;
  }
  .mint-button--primary {
    background: #E4393C;
  }

  .btn {
    height: .94rem;
    line-height: .94rem;
    font-weight: 500;
  }
</style>
<style>
  .mint-header-title {
    font-size: .36rem;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/views/more/newphone.vue